/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CreateTouchpointPathParameters,
  CreateTouchpointsFromMondayTemplatesPathParameters,
  CreateTouchpointsWithWriterRequest,
  CreateWriterTouchpointsPathParameters,
  DeleteTouchpointPathParameters,
  GetAllTouchpointsForCampaignParams,
  GetAllTouchpointsForCampaignPathParameters,
  GetLatestBatchPathParameters,
  GetTouchpointPathParameters,
  MondayTouchpointTemplateDTO,
  PagedModelCampaignTouchpointSummaryDTO,
  PartiallyUpdateTouchpointPathParameters,
  RetrySyncTouchpointPathParameters,
  RewriteEmailsAsyncPathParameters,
  RewriteTouchpointContentsDTO,
  RewriteTouchpointContentsRequest,
  TouchpointBatchBaseDTO,
  TouchpointCreateRequest,
  TouchpointDTO,
  TouchpointPatchRequest,
  TouchpointUpdateRequest,
  UpdateTouchpointPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getTouchpoint = () => {
  /**
 * Get a touchpoint

Required authority: PERM_TOUCHPOINT_READ
 */
  const getTouchpoint = ({ clientId, campaignId, id }: GetTouchpointPathParameters) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}`,
      method: "GET",
    });
  };
  /**
 * Update a touchpoint

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const updateTouchpoint = (
    { clientId, campaignId, id }: UpdateTouchpointPathParameters,
    touchpointUpdateRequest: TouchpointUpdateRequest,
  ) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: touchpointUpdateRequest,
    });
  };
  /**
 * Delete touchpoint with all the associated versions

Required authority: PERM_TOUCHPOINT_ADVANCED
 */
  const deleteTouchpoint = ({ clientId, campaignId, id }: DeleteTouchpointPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}`,
      method: "DELETE",
    });
  };
  /**
 * Update a touchpoint

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const partiallyUpdateTouchpoint = (
    { clientId, campaignId, id }: PartiallyUpdateTouchpointPathParameters,
    touchpointPatchRequest: TouchpointPatchRequest,
  ) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: touchpointPatchRequest,
    });
  };
  /**
 * Get all touchpoints for campaign

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAllTouchpointsForCampaign = (
    { clientId, campaignId }: GetAllTouchpointsForCampaignPathParameters,
    params?: GetAllTouchpointsForCampaignParams,
  ) => {
    return customInstance<PagedModelCampaignTouchpointSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a touchpoint

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createTouchpoint = (
    { clientId, campaignId }: CreateTouchpointPathParameters,
    touchpointCreateRequest: TouchpointCreateRequest,
  ) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: touchpointCreateRequest,
    });
  };
  /**
 * Rerun failed sync job

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const retrySyncTouchpoint = ({ clientId, campaignId, id }: RetrySyncTouchpointPathParameters) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}/monday-retry-sync`,
      method: "POST",
    });
  };
  /**
 * Create touchpoints in a campaign from writer creatives

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createWriterTouchpoints = (
    { clientId, campaignId }: CreateWriterTouchpointsPathParameters,
    createTouchpointsWithWriterRequest: CreateTouchpointsWithWriterRequest,
  ) => {
    return customInstance<TouchpointDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/writer-touchpoints`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTouchpointsWithWriterRequest,
    });
  };
  /**
 * Rewrite email creatives in a campaign via background jobs. Rewrites every eligible email creative when no touchpoint ids are supplied

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const rewriteEmailsAsync = (
    { clientId, campaignId }: RewriteEmailsAsyncPathParameters,
    rewriteTouchpointContentsRequest: RewriteTouchpointContentsRequest,
  ) => {
    return customInstance<RewriteTouchpointContentsDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/rewrite-emails-async`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rewriteTouchpointContentsRequest,
    });
  };
  /**
 * Create touchpoints from templates for a campaign

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createTouchpointsFromMondayTemplates = (
    { clientId, campaignId }: CreateTouchpointsFromMondayTemplatesPathParameters,
    mondayTouchpointTemplateDTO: MondayTouchpointTemplateDTO[],
  ) => {
    return customInstance<TouchpointDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/monday-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mondayTouchpointTemplateDTO,
    });
  };
  /**
 * Get latest batch for a touchpoint when the most recently added batch is BUILDING or IN_REVIEW

Required authority: PERM_TOUCHPOINT_READ
 */
  const getLatestBatch = ({ clientId, campaignId, id }: GetLatestBatchPathParameters) => {
    return customInstance<TouchpointBatchBaseDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${id}/latest-batch`,
      method: "GET",
    });
  };
  return {
    getTouchpoint,
    updateTouchpoint,
    deleteTouchpoint,
    partiallyUpdateTouchpoint,
    getAllTouchpointsForCampaign,
    createTouchpoint,
    retrySyncTouchpoint,
    createWriterTouchpoints,
    rewriteEmailsAsync,
    createTouchpointsFromMondayTemplates,
    getLatestBatch,
  };
};
export type GetTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["getTouchpoint"]>>
>;
export type UpdateTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["updateTouchpoint"]>>
>;
export type DeleteTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["deleteTouchpoint"]>>
>;
export type PartiallyUpdateTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["partiallyUpdateTouchpoint"]>>
>;
export type GetAllTouchpointsForCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["getAllTouchpointsForCampaign"]>>
>;
export type CreateTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["createTouchpoint"]>>
>;
export type RetrySyncTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["retrySyncTouchpoint"]>>
>;
export type CreateWriterTouchpointsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["createWriterTouchpoints"]>>
>;
export type RewriteEmailsAsyncResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["rewriteEmailsAsync"]>>
>;
export type CreateTouchpointsFromMondayTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["createTouchpointsFromMondayTemplates"]>>
>;
export type GetLatestBatchResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpoint>["getLatestBatch"]>>
>;
